import { Dialog } from "@headlessui/react";
import Image from "next/image";
import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/button";
import { Close } from "@/components/icons/close";
import { Link } from "@/components/link";
import useAnalytics from "@/hooks/use-analytics";
import useEvent from "@/hooks/use-event";
import endpoints from "@/utils/endpoints";

import upsellImg from "./upsell.jpeg";

const get = endpoints();

interface UpsellModalProps {
  isShowing: boolean;
  onClose: () => void;
}

export default function UpsellModal({ isShowing, onClose }: UpsellModalProps) {
  const { event } = useEvent();
  const { logAnalytics } = useAnalytics();
  const { t } = useTranslation();

  return (
    <Dialog open={isShowing} onClose={onClose} className="relative z-50">
      <div
        className="fixed inset-0 bg-[#000a26]/60 backdrop-blur-sm"
        aria-hidden="true"
      />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <Dialog.Panel className="relative w-full max-w-md rounded-lg bg-white shadow-lg">
            <button
              onClick={onClose}
              className="absolute right-3 top-3 rounded p-1 text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500  focus:ring-offset-2"
              aria-label="Close"
            >
              <Close className="size-6" />
            </button>

            <div className="p-6 text-center">
              <div className="flex flex-col gap-2">
                <div className="mx-auto max-w-[188px]">
                  <Image
                    src={upsellImg}
                    objectFit="contain"
                    unoptimized
                    height={upsellImg.height}
                    width={upsellImg.width}
                    alt=""
                  />
                </div>
                <h2 className="font-semibold leading-relaxed text-gray-900">
                  {t("upsell-modal.upgrade-your-plan")}
                </h2>
                <p className="text-sm !leading-relaxed text-gray-600">
                  {t("upsell-modal.business-plan-benefits", {
                    payment_plan_name: event.organization.payment_plan_name,
                  })}
                </p>
              </div>
            </div>

            <div className="flex gap-4 border-t border-solid border-gray-300 p-6">
              <Button variant="outlined" onClick={onClose}>
                {t("upsell-modal.dismiss-button")}
              </Button>
              <Link
                className="w-full"
                href={get("HOPIN_BILLING")}
                onClick={() => {
                  logAnalytics("CANVAS_EDITOR_UPGRADE_MODAL_CLICKED", {
                    upgrade_source: "upgrade_modal",
                  });
                }}
              >
                {t("common.upgrade-plan")}
              </Link>
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
